import api from '@/api';

class PropertyTenure {
  /**
   * Index / Get listing of distinct property tenures for the client properties
   * @returns {*}
   */
  static list(clientId, params) {
    params.params.pathname = window.location.pathname;
    return api.get(`/clients/${clientId}/properties-tenure`, params);
  }
}

export default PropertyTenure;
